module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_9005.4ee20142.png";